import { Box, Center, Spinner, Text, VStack } from '@chakra-ui/react';

interface RouteLoadingProps {
  message?: string;
}

export default function RouteLoading({ message = 'Loading...' }: RouteLoadingProps) {
  return (
    <Center h="100vh" w="100vw">
      <VStack spacing={4}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="brand.primary"
          size="xl"
        />
        <Text color="gray.600" fontSize="md">
          {message}
        </Text>
      </VStack>
    </Center>
  );
}
